module.exports = "<select>\n    <option selected>---</option>\n    {{{timePicker}}}\n</select>"